import {
  AddressInfo,
  DesignationInfo,
  StatusInfo,
  EmployeeInfo,
  AddressDto,
  DesignationDto,
  PreDesignationDto,
  StatusDto,
  CompanyDto,
  EmployeeDtoProfile,
  EmployeeDtoProof,
  InitialValues
} from "./types/EditEmployeeDetailsTypes";

const imageBaseUrl = process.env.REACT_APP_IMAGE_VIEW;
const createAddress = (addressInfo: AddressInfo): AddressDto => {
  return {
    doorNo: addressInfo?.doorNo ?? "",
    street: addressInfo?.street ?? "",
    city: addressInfo?.city ?? "",
    state: addressInfo?.state ?? "",
    pinCode: addressInfo?.pinCode ?? "",
    addressId: addressInfo?.addressId ?? "",
  };
};

const createDesignationDto = (designationInfo: DesignationInfo | undefined): DesignationDto => {
  return {
    designationId: designationInfo?.designationId ?? "",
  };
};

const createPreDesignationDto = (designationInfo: DesignationInfo | undefined): PreDesignationDto => {
  return {
    preDesignationId: designationInfo?.designationId ?? "",
  };
};

const createStatusDto = (statusInfo: StatusInfo | undefined): StatusDto => {
  return {
    statusId: statusInfo?.statusId ?? "",
  };
};

const createCompanyDto = (info: EmployeeInfo): CompanyDto => {
  return {
    dateOfJoin: info?.dateOfJoin ?? "",
    designationEffectiveDate: "",
    nextProbationEndDate: info?.nextProbationEndDate ?? "",
    reportingManagerId: info?.reportingManager?.employeeId ?? "",
    initiatingManagerId: info?.initiationManager?.employeeId ?? "",
    backGroundVerification: info?.backGroundVerification ?? "",
    grade: info?.designation?.grade?.name ?? "",
    designationDto: createDesignationDto(info?.designation),
    preDesignationDto: createPreDesignationDto(info?.designation),
    statusDto: createStatusDto(info?.status),
    departmentId: info?.department?.departmentId ?? "",
    employeeTypeId: info?.employeeType?.employeeTypeId ?? "",
    officialEmailId: info?.officialEmail ?? "",
  };
};

const createEmployeeDtoProfile = (info: EmployeeInfo): EmployeeDtoProfile => {
  return {
    firstName: info?.firstName ?? "",
    lastName: info?.lastName ?? "",
    dateOfBirth: info?.dateOfBirth ?? "",
    bloodGroup: info?.bloodGroup ?? "",
    fatherOrSpouseName: info?.fatherOrSpouseName ?? "",
    fatherName: info?.fatherName ?? "",
    motherName: info?.motherName ?? "",
    personalContactNo: info?.personalContactNo ?? "",
    personalEmail: info?.personalEmail ?? "",
  };
};

const createEmployeeDtoProof = (info: EmployeeInfo): EmployeeDtoProof => {
  return {
    aadharNumber: info?.aadharNumber ?? "",
    panNumber: info?.panNumber ?? "",
    uanNumber: info?.uanNumber ?? "",
    esiNumber: info?.esiNumber ?? "",
    gender: info?.gender ?? "M",
    isMarried: info?.isMarried ?? false,
    sameAsCurrentAddress: info?.sameAsCurrentAddress ?? "",
    presentAddress: createAddress(info?.presentAddress as AddressInfo),
    permanentAddress: createAddress(info?.permanentAddress as AddressInfo),
    emergencyContactNo1: info?.emergencyContactNo1 ?? "",
    emergencyContactNo1Relationship: info?.emergencyContactNo1Relationship ?? "",
    emergencyContactNo2: info?.emergencyContactNo2 ?? "",
    emergencyContactNo2Relationship: info?.emergencyContactNo2Relationship ?? "",
    isWorkFromHome: info?.isWorkFromHome,
    identificationMark: info?.identificationMark ?? "",
  };
};

export const handleSetInitialValues = (
  info: EmployeeInfo,
  setEmployeeImage: (url: string) => void,
  setInitialvalues: (values: InitialValues) => void,
  setCompantDto: (dto: CompanyDto) => void
) => {
  const empInfo: InitialValues = {
    employeeDto: {
      ...createEmployeeDtoProfile(info),
      ...createEmployeeDtoProof(info),
    },
    companyDto: createCompanyDto(info),
    assertId: info?.employeeAssertInfo?.assertId,
  };
  setEmployeeImage(`${imageBaseUrl}${info?.profileUrl}`);
  setInitialvalues(empInfo);
  setCompantDto(empInfo?.companyDto);
};


